module.exports = __webpack_public_path__ + "static/img/icon_giftcard_return.22390af3.png";